import type { IInputBlockProps } from './InputBlock'

import { styled } from '@linaria/react'
import { InputLabel } from 'atoms/Input'
import { FIXED_INDENTS } from 'vars/index'

export const InputBlockStyled = styled.div<
  Pick<IInputBlockProps, 'width' | 'rowGap' | 'margins'>
>`
  width: ${({ width }) => (width ? `${width}%` : 'auto')};
  margin: ${({ margins }) =>
    margins && margins.length > 0
      ? margins.map((item) => `var(${item})`)?.join(' ')
      : 0};

  ${InputLabel} {
    margin-bottom: ${({ rowGap }) =>
      `var(${rowGap?.[0] || FIXED_INDENTS.INDENT_0})`};
  }
`
